// istanbul ignore file : formatDateTime had no test or usage

import React, { useMemo } from 'react';
import { useIntl } from 'react-intl';
import { ITranslator } from 'types/intl';

const AppIntl: React.FC = () => {
	const intl = useIntl();

	globalThis.intl = useMemo<ITranslator>(
		() => ({
			...intl,
			tr: (id: string, values?: any, defaultMessage?: string) =>
				intl.formatMessage({ id, defaultMessage }, values),
			formatDateTime: (rawTime?: any) => {
				if (!rawTime) {
					return intl.formatMessage({ id: 'app.na' });
				}
				const parts = intl.formatDate(rawTime, { year: 'numeric' });
				let readyTime = rawTime;
				if (parts === '1970') {
					readyTime *= 1000;
				}
				return `${intl.formatDate(readyTime, {
					year: 'numeric',
					month: 'long',
					day: '2-digit'
				})} ${intl.formatTime(readyTime, {
					hourCycle: 'h23'
				})}`;
			}
		}),
		[intl]
	);

	return null;
};

export default AppIntl;
